export default "__VITE_ASSET__Bdsz3EVq__"